require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-partners-with-fox-59-pack-the-pantries-to-raise-usd-95-000.json") })
        }
      }, "path---articles-financial-center-partners-with-fox-59-pack-the-pantries-to-raise-usd-95-000");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-partners-with-fox-59-pack-the-pantries-to-raise-usd-95-000!./.cache/json/articles-financial-center-partners-with-fox-59-pack-the-pantries-to-raise-usd-95-000.json
// module id = 1656
// module chunks = 231608221292675